import { useEffect, useState } from 'react'
import { ProfileApi, UnitAssignedToUser } from '@/api/models/profile'
import { useAuth } from '@/features/auth/useAuth'

export const useGetUserPrimaryUnit = () => {
  const { user } = useAuth()

  const [units, setUnits] = useState<UnitAssignedToUser[]>([])

  useEffect(() => {
    if (!user) return

    ProfileApi.units(user.id).then((response) => {
      setUnits(response.items)
    })
  }, [user])

  return (units ?? []).find((userUnitRelation) => userUnitRelation.membership?.[0]?.is_primary)?.unit
}
